export default __webpack_public_path__ + "assets/79351a1df15e6a44111933a4e53c5113/amenities-03.jpg";